import {
  Component,
  computed,
  ElementRef,
  HostBinding,
  OnInit,
  signal,
} from '@angular/core';
import { AiFeaturesService, AIStore } from '@maximizer/ai/data-access';
import {
  ContextService,
  SessionService,
} from '@maximizer/core/shared/data-access';
import { EmbeddedComponent } from '@maximizer/core/shared/ui/components/base';
import { UI_KENDO } from '@maximizer/core/shared/ui/kendo';
import { UI_PIPES } from '@maximizer/core/shared/ui/pipes';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_TOOLTIP } from '@progress/kendo-angular-tooltip';
import { switchMap, tap } from 'rxjs';
import { IQBoostInternalCommand } from '../classes/iqboost';

@Component({
  selector: 'ai-iqboost-launcher',
  template: `
    <div
      kendoTooltip
      [popupTarget]="element"
      [tooltipTemplate]="aiDisabledTooltip"
      [showOn]="this.isEnabled() ? 'none' : 'hover'"
      [callout]="false"
      filter=".ai-button"
      class="flex"
    >
      @if (isLoaded() &&showIQBoost()) {
        <div class="ml-4 ai-button">
          <button
            kendoButton
            class="bg-primary-180 border-none w-8.5 h-8.5 hover:bg-primary-160"
            [disabled]="!this.isEnabled()"
            (click)="launchIqboost()"
          >
            <span 
              class="maximizer-icons icon-solid icon-20 icon-iq-boost"
              [class.text-primary-80]="this.isEnabled()"
              [class.text-primary-160]="!this.isEnabled()"
            >
            </span>
          </button>
        </div>
      }
    </div>
    <ng-template #aiDisabledTooltip>
      <p
        class="text-caption whitespace-pre-wrap"
        [innerHTML]="
          'JSS_GenAiFeaturesDisabled'
            | resourceOrTranslate: 'ai.disabled'
            | regexReplace: '\\\\r\\\\n' : '\r\n'
        "
      ></p>
    </ng-template>
  `,
  imports: [KENDO_BUTTON, KENDO_TOOLTIP, UI_KENDO, UI_PIPES],
})
export class IqboostLauncherComponent
  extends EmbeddedComponent
  implements OnInit
{
  @HostBinding('attr.id') id = 'ai-iqboost-launcher';
  @HostBinding('class') aiClass = 'ai-ng';

  isEnabled = signal(false);
  isLoaded = signal(false);
  showIQBoost = computed(() => this.aiFeaturesService.showIQBoost());

  constructor(
    element: ElementRef,
    private readonly context: ContextService,
    public readonly aiStore: AIStore,
    private readonly session: SessionService,
    private readonly aiFeaturesService: AiFeaturesService,
  ) {
    super(element);
  }

  ngOnInit(): void {
    this.session.getInfo()
      .pipe(
        switchMap((session) => this.aiFeaturesService.getConfiguration(session)),
        tap((config) => {
          this.aiStore.setUserDataGroup(config.aiUserDataGroup);
          this.isEnabled.set(config.enabled);
        }),
        tap(() => this.isLoaded.set(true)),
      )
      .subscribe();
  }

  override doAction(name: string, args?: unknown): void {
      if (name === IQBoostInternalCommand.SetEnabled) {
      this.isEnabled.set(args as boolean);
    }
  }

  launchIqboost(): void {
    this.context.showComponentDialog('maximizer-ai-iqboost', {
      key: '',
      type: '',
    });
  }
}
